import React from 'react';
import Navbar from './navbar/Navbar';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import Footer from './footer/Footer';

function Layout(props) {
    const location = useLocation();
    const { id: bookId } = useParams()
    const isBookView = location.pathname.startsWith('/library') && bookId
    const hideFooter = /^\/library\/\d+$/.test(location.pathname);

    return (
        <div className="flex flex-col min-h-screen">
            <header>
                <Navbar/>
            </header>

            <main className={`${isBookView ? 'overflow-hidden' : 'mx-auto px-[10px] desktop:px-6 max-w-[1440px]'} flex-grow`}>
                <Outlet />
            </main>

            {!hideFooter && (
              <footer className='w-full' id={'footer'}>
                  <Footer/>
              </footer>
            )}
        </div>
    );
}

export default Layout;
